"use client";

import { FC } from "react";
import { ApolloProvider } from "@apollo/client";

import { SearchProvider } from "context";
import { client } from "services";

import { Search, SearchProps } from "./Search";

interface Props extends SearchProps {
  itemsCount: number;
}

export const SearchContainer: FC<Props> = (props) => (
  <SearchProvider
    initialSearchData={{
      offset: 0,
      itemsPerPage: 24,
      total: props.itemsCount,
    }}
  >
    <ApolloProvider client={client}>
      <Search {...props} />
    </ApolloProvider>
  </SearchProvider>
);
